import { MyAccountUsersQuery } from '@/gql/graphql';
import { User } from '@payaca/types/userTypes';

type GraphqlAccountUser =
  MyAccountUsersQuery['me']['user']['account']['users'][number];

/**
 * Maps a GraphQL account user onto the legacy REST User shape.
 *
 * Contract notes:
 * - `id` is the numeric database id, carried as a string over GraphQL.
 * - `costPerHour` is the bare minor-units amount from `CurrencyValue.value`.
 */
export const toLegacyAccountUser = (u: GraphqlAccountUser) =>
  ({
    id: Number(u.id),
    publicId: u.publicId,
    firstname: u.firstName,
    lastname: u.lastName,
    name: u.fullName,
    email: u.email ?? '',
    userColour: u.colour ?? undefined,
    avatarUrl: u.avatarUrl ?? undefined,
    systemRole: u.systemRole,
    deactivatedAt: u.deactivatedAt ?? null,
    status: u.status,
    costPerHour: u.costPerHour?.value ?? null,
    isPrimaryAccountUser: u.isPrimaryUser,
    sortOrder: u.sortOrder,
    contactNumber: u.phone ?? undefined,
  }) satisfies Partial<User> & { status: string };

/** The subset of the legacy User shape the adapter actually provides. */
export type LegacyAccountUser = ReturnType<typeof toLegacyAccountUser>;
